import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const BackgroundElement = styled.span `
  width: ${fluid(156, 596)};
  position: absolute;
  opacity: 0.12;
  animation: var(--animation) var(--speed) infinite linear alternate;
  transform: none;
  mix-blend-mode: screen;
  pointer-events: none;
  user-select: none;

  &:nth-of-type(1) {
    --speed: 12s;
    --animation: movement;

    top: var(--y, 0%);
    left: var(--x, 0%);

    @media ${from(Device.Tablet)} {
      --speed: 18s;
    }

    @media ${from(Device.Desktop)} {
      --speed: 24s;
    }

    @keyframes movement {
      0% {
        transform: none;
      }

      25% {
        transform: translate(72%, -40%) rotate(40deg);
      }

      50% {
        transform: translate(133%, -20%) scale(0.66) rotate(20deg);
      }

      100% {
        transform: translate(50%, -60%) rotate(40deg);
      }
    }
  }

  &:nth-of-type(2) {
    --speed: 9s;
    --animation: movement2;

    top: var(--y, 50%);
    left: var(--x, 50%);
    transform: scale(0.8) rotate(-24deg);

    @media ${from(Device.Tablet)} {
      --speed: 13s;
    }

    @media ${from(Device.Desktop)} {
      --speed: 20s;
    }

    @keyframes movement2 {
      0% {
        transform: scale(0.8) rotate(-24deg);
      }

      25% {
        transform: translate(32%, -33%) scale(1) rotate(-33deg);
      }

      50% {
        transform: translate(-12%, -60%) scale(0.8) rotate(20deg);
      }

      100% {
        transform: translate(64%, -20%) scale(0.5) rotate(-16deg);
      }
    }
  }

  &:nth-of-type(3) {
    --speed: 14s;
    --animation: movement3;

    top: var(--y, 75%);
    left: var(--x, 75%);

    @media ${from(Device.Tablet)} {
      --speed: 20s;
    }

    @media ${from(Device.Desktop)} {
      --speed: 29s;
    }

    @keyframes movement3 {
      0% {
        transform: none;
      }

      25% {
        transform: translate(12%, 44%) scale(1.2) rotate(-12deg);
      }

      50% {
        transform: translate(-100%, -32%) scale(0.8) rotate(20deg);
      }

      100% {
        transform: translate(56%, -90%) scale(1) rotate(60deg);
      }
    }
  }
`;
const FloatingBackgroundElementsStyles = {
    BackgroundElement,
};
export default FloatingBackgroundElementsStyles;
